import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import * as permissionKind from '../../../../shared/permissions';
import { type UserSpecsFragment } from '../../../api/fragments/UserSpecs';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import NoItemResult from '../../../components/results/NoItemResult';
import hasPermissions from '../../../utilities/hasPermissions';

export type UserPermissionEmptyListProps = { user: UserSpecsFragment };

const UserPermissionEmptyList = ({ user }: UserPermissionEmptyListProps) => {
    const { userId } = useParams<{ userId: string }>();
    const { t } = useTranslation(['userDetails']);
    const navigate = useNavigate();
    const { permissions: accountPermissions } = useAccount();
    const hasPermission = hasPermissions(accountPermissions, [permissionKind.updateUser]);

    return (
        <NoItemResult
            extra={
                hasPermission && (
                    <Button onClick={() => navigate(`/admin/accesses/users/${userId}/update`)} type="primary">
                        {t('userDetails:permissions.noData.action')}
                    </Button>
                )
            }
            subTitle={t('userDetails:permissions.noData.message')}
        />
    );
};

export default UserPermissionEmptyList;
